import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { getWholesaleVendors } from "../../Vendors/apiService";

import { RowLine, HeaderRowLine, RowField, CheckField, AmountField, ActionField, BasicRowField } from "../../../utils/utilities/SelectableTableFields";

import { Switch } from "@mui/material";

import { useFormikContext } from "formik";

import { useFormData } from "../../../contexts/FormData";

import { BasicFlex } from "../../../utils/Common";

const Brands = () => {

  const { values } = useFormikContext();

  const { formValues, setFormValues } = useFormData();

  const { data: brands } = useQuery({
    queryKey: ["brands"],
    queryFn: getWholesaleVendors,
    enabled: values?.scope === "brand",
    staleTime: Infinity
  });


  useEffect(() => {
    if (values?.scope === "brand" && brands) {
      setFormValues(ofv => ({ ...ofv, brands: brands?.map(el => ({brand_name: el.brand_name, selected: false})) }));
    }
  }, [brands]);

  const handleChange = (e, index) => {
    const newBrands = [...formValues?.brands];
    newBrands[index].selected = e.target.checked;
    setFormValues(ofv => ({ ...ofv, brands: newBrands }));
  }

  return (
    <BasicFlex dir="column" >
      {formValues?.brands?.map((el, index) => (
        <RowLine key={el.brand_name}>
          <ActionField $justify="flex-start">
            <Switch checked={el.selected} onChange={(e) => handleChange(e, index)} size="small" />
          </ActionField>
          <BasicRowField $justify="flex-start" $borderless>{el.brand_name}</BasicRowField>
        </RowLine>
      ))}
    </BasicFlex>
  )
};

export default Brands;